import packageConfig from '../../package.json';

export default {
  apiVersion: '1',
  clientVersion: 'android-' + packageConfig.version, // TODO: add dynamic device capabilities
  root: apiRoot()
};

function apiRoot() {
  if ( process.env.STAGING_ENV === 'development' ) {
    return 'https://ct151-api.development.clicktherapeuticsdev.com/';
  } else if ( process.env.STAGING_ENV === 'beta'
            || process.env.STAGING_ENV === 'beta-internal'
            || process.env.STAGING_ENV === 'qa' ) {
    return 'https://ct151-api.beta.clicktherapeuticsdev.com/';
  } else if ( process.env.STAGING_ENV === 'prod' ) {
    return 'https://ct151-api.clicktherapeutics.com/';
  }
  return 'http://docker-host:3000/';
}



// WEBPACK FOOTER //
// ./src/config/api.js